import AlignPopup from './AlignPopup';
import AlignSubmenu from './AlignSubmenu';

export { AlignSubmenu };

export default AlignPopup;
